/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: wboCjrKjkicgLwUG7d8r4V
// Component: _rQb9zd5dUuy

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import CreditSlider from "../../CreditSlider"; // plasmic-import: uHY7fCWscEWp/component
import PrimaryButton from "../../PrimaryButton"; // plasmic-import: vB7QgUC5rmaN/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: wboCjrKjkicgLwUG7d8r4V/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: wboCjrKjkicgLwUG7d8r4V/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicSliderForm.module.css"; // plasmic-import: _rQb9zd5dUuy/css

import CircleIcon from "./icons/PlasmicIcon__Circle"; // plasmic-import: CMNsVVM_CTAi/icon
import ChevronDown2Icon from "./icons/PlasmicIcon__ChevronDown2"; // plasmic-import: HOj16Al_mbLY/icon

createPlasmicElementProxy;

export type PlasmicSliderForm__VariantMembers = {};
export type PlasmicSliderForm__VariantsArgs = {};
type VariantPropType = keyof PlasmicSliderForm__VariantsArgs;
export const PlasmicSliderForm__VariantProps = new Array<VariantPropType>();

export type PlasmicSliderForm__ArgsType = {
  onAmountChange?: (val: string) => void;
  children?: React.ReactNode;
};
type ArgPropType = keyof PlasmicSliderForm__ArgsType;
export const PlasmicSliderForm__ArgProps = new Array<ArgPropType>(
  "onAmountChange",
  "children"
);

export type PlasmicSliderForm__OverridesType = {
  root?: Flex__<"div">;
  h2?: Flex__<"h2">;
  freeBox?: Flex__<"div">;
  creditSlider?: Flex__<typeof CreditSlider>;
};

export interface DefaultSliderFormProps {
  onAmountChange?: (val: string) => void;
  children?: React.ReactNode;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicSliderForm__RenderFunc(props: {
  variants: PlasmicSliderForm__VariantsArgs;
  args: PlasmicSliderForm__ArgsType;
  overrides: PlasmicSliderForm__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "amount",
        type: "readonly",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          (() => {
            try {
              return $state.creditSlider.sliderValue;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return 17000;
              }
              throw e;
            }
          })(),

        onChangeProp: "onAmountChange"
      },
      {
        path: "creditSlider.sliderValue",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      }
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_wboCjrKjkicgLwUG7d8r4V",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      <div className={classNames("all", "__wab_text", sty.text__m3G49)}>
        <React.Fragment>
          <React.Fragment>{""}</React.Fragment>
          {
            <h2
              data-plasmic-name={"h2"}
              data-plasmic-override={overrides.h2}
              className={classNames(
                "all",
                "h2",
                "h2__wboCj",
                "__wab_text",
                sty.h2
              )}
            >
              {"P\u016fj\u010dka bleskov\u011b"}
            </h2>
          }
          <React.Fragment>{""}</React.Fragment>
        </React.Fragment>
      </div>
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames("all", sty.freeBox)}
      >
        <CreditSlider
          data-plasmic-name={"creditSlider"}
          data-plasmic-override={overrides.creditSlider}
          className={classNames("__wab_instance", sty.creditSlider)}
          onSliderValueChange={async (...eventArgs: any) => {
            generateStateOnChangeProp($state, [
              "creditSlider",
              "sliderValue"
            ]).apply(null, eventArgs);

            if (
              eventArgs.length > 1 &&
              eventArgs[1] &&
              eventArgs[1]._plasmic_state_init_
            ) {
              return;
            }
          }}
        />
      </div>
      <div className={classNames("all", "__wab_text", sty.text__zwWa4)}>
        {
          "Ide\u00e1ln\u00ed p\u016fj\u010dka na\u0161ich z\u00e1kazn\u00edk\u016f je 20 000 K\u010d v d\u00e9lce od 3 do 36 m\u011bs\u00edc\u016f, s \u00farokem 2,99 % p. a., Max. RPSN 4,39 %. M\u011bs\u00ed\u010dn\u00ed spl\u00e1tka 594 K\u010d. Celkem k zaplacen\u00ed 24 967 K\u010d. V\u00fdpo\u010det je pouze ilustrativn\u00ed, kone\u010dn\u00fd \u00farok ur\u010d\u00ed poskytovatel. "
        }
      </div>
      {renderPlasmicSlot({
        defaultContents: (
          <PrimaryButton
            className={classNames("__wab_instance", sty.primaryButton__b8UxT)}
            color={"neutral"}
            label={
              <div className={classNames("all", "__wab_text", sty.text__ww2A3)}>
                {"P\u016fj\u010dit v\u00fdhodn\u011b te\u010f"}
              </div>
            }
            onClick={async event => {
              const $steps = {};

              $steps["updateVariable"] = true
                ? (() => {
                    const actionArgs = {
                      variable: {
                        objRoot: $state,
                        variablePath: ["amount"]
                      },
                      operation: 0
                    };
                    return (({ variable, value, startIndex, deleteCount }) => {
                      if (!variable) {
                        return;
                      }
                      const { objRoot, variablePath } = variable;

                      $stateSet(objRoot, variablePath, value);
                      return value;
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["updateVariable"] != null &&
                typeof $steps["updateVariable"] === "object" &&
                typeof $steps["updateVariable"].then === "function"
              ) {
                $steps["updateVariable"] = await $steps["updateVariable"];
              }
            }}
          />
        ),

        value: args.children
      })}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "h2", "freeBox", "creditSlider"],
  h2: ["h2"],
  freeBox: ["freeBox", "creditSlider"],
  creditSlider: ["creditSlider"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  h2: "h2";
  freeBox: "div";
  creditSlider: typeof CreditSlider;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSliderForm__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSliderForm__VariantsArgs;
    args?: PlasmicSliderForm__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicSliderForm__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicSliderForm__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSliderForm__ArgProps,
          internalVariantPropNames: PlasmicSliderForm__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSliderForm__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSliderForm";
  } else {
    func.displayName = `PlasmicSliderForm.${nodeName}`;
  }
  return func;
}

export const PlasmicSliderForm = Object.assign(
  // Top-level PlasmicSliderForm renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    h2: makeNodeComponent("h2"),
    freeBox: makeNodeComponent("freeBox"),
    creditSlider: makeNodeComponent("creditSlider"),

    // Metadata about props expected for PlasmicSliderForm
    internalVariantProps: PlasmicSliderForm__VariantProps,
    internalArgProps: PlasmicSliderForm__ArgProps
  }
);

export default PlasmicSliderForm;
/* prettier-ignore-end */
